import { createContext } from 'react';

import { HistogramSeries } from '../types/histogram.js';

export const HistogramXBottomUnit =
  createContext<HistogramSeries['unit']>(undefined);

HistogramXBottomUnit['displayName'] = 'HistogramXBottomUnit';
